@if (true) {
<div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
        <div class="modal-content">
            <div class="modal-header BlueHeader">
                <h4 class="Heading">{{ModalHeading}}</h4><br>
                <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]('')"
                    data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body  col-sm-12 form-group">
                <iframe width="100%" Height="500 px" frameBorder="0" [src]="modalURL|safe"></iframe>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="table-header-container my-3">
        <div class="table-heading">
            Escalation Configuration
        </div>
        <form [formGroup]="FormSearchNoticeCase">
            <div class="col-sm-12 text-left">
            <div class="btn-group" role="group" aria-label="Module Selection">
                @for (module of Modules; track $index; let i = $index) {
                    <input type="radio"
                        class="btn-check"
                        name="Modules"
                        [id]="'module_' + module.MainID"
                        formControlName="Modules"
                        [value]="module.MainID"
                        [(ngModel)]="ModuleSelected"
                        (change)="onModuleSelect(module.MainID)"
                        autocomplete="off">
    
                    <label class="btn btn-outline-primary" [ngStyle]="{'border-radius' : i == 0 ? '4px 0 0 4px' : ''}"
                        [for]="'module_' + module.MainID">
                    {{ module.MainDescr }}
                    </label>
                }
            </div>
            </div>
        </form>
    </div>
    <div class="card table-container">
        <table class="custom-table">
            <thead>
                <tr>
                    <th rowspan="2">Report</th>
                    <th rowspan="2">Employee</th>
                    <th colspan="3" class="text-center">Level 1</th>
                    <th colspan="3" class="text-center">Level 2</th>
                    <th colspan="3" class="text-center">Level 3</th>
                    <th rowspan="2" class="text-center">Non User Email</th>
                    <th rowspan="2" class="text-center">Action</th>
                </tr>
                <tr>
                    <th class="center">Days</th>
                    <th class="center">Interval</th>
                    <th>Send Mail To</th>
                    <th class="center">Days</th>
                    <th class="center">Interval</th>
                    <th>Send Mail To</th>
                    <th class="center">Days</th>
                    <th class="center">Interval</th>
                    <th>Send Mail To</th>
                </tr>
            </thead>
            <tbody>
                <app-table-state [loading]="MsgType == 1"
                    [error]="MsgType == 3 ? 'Something went wrong while fetching data.' : null" [empty]="MsgType == 2"
                    [rows]="10" [columns]="13">
                </app-table-state>
                @for (mDtl of Data; track $index; let i = $index) {
                    <tr>
                        <td>
                            @if (i == 0) {
                            <a class="link" style="color:#337ab7;" data-toggle="modal"
                                (click)="OpenModalFeature('escalation-report-entry/' + mDtl.ReportID); "
                                data-target="#ModalPopUP">{{mDtl.ReportName}}</a>
                            }@else if(Data[i-1].ReportID != mDtl.ReportID) {
                            <div>
                                <a class="link" style="color:#337ab7;" data-toggle="modal"
                                    (click)="OpenModalFeature('escalation-report-entry/' + mDtl.ReportID); "
                                    data-target="#ModalPopUP">{{mDtl.ReportName}}</a>
                            </div>
                            }
                        </td>
    
                        <td>
                            <a class="link" style="color:#337ab7;" target="_blank" data-toggle="modal"
                                (click)="OpenModal('escalation-user-entry',mDtl.ReportID, mDtl.UserID); "
                                data-target="#ModalPopUP">{{mDtl.UserName}}</a>
                        </td>
                        <td class="center"> {{mDtl.L1Days}} </td>
                        <td class="center"> {{mDtl.L1Interval}} </td>
                        <td> {{mDtl.L1Users}} </td>
    
                        <td class="center"> {{mDtl.L2Days}} </td>
                        <td class="center"> {{mDtl.L2Interval}} </td>
                        <td> {{mDtl.L2Users}} </td>
    
                        <td class="center"> {{mDtl.L3Days}} </td>
                        <td class="center"> {{mDtl.L3Interval}} </td>
                        <td> {{mDtl.L3Users}} </td>
                        <td> {{mDtl.Email}} </td>
                        <td class="center">
                            @if (i == 0) {
                            <button class="icon-btn icon-btn-primary" data-toggle="modal" title="Add Employee"
                                data-target="#ModalPopUP" (click)="OpenModal('escalation-user-entry',mDtl.ReportID,0); ">
                                <i class="fa-solid fa-plus"></i>
                            </button>
    
                            }@else if(Data[i-1].ReportID != mDtl.ReportID) {
                            <button class="icon-btn icon-btn-primary" data-toggle="modal" title="Add Employee"
                                data-target="#ModalPopUP" (click)="OpenModal('escalation-user-entry',mDtl.ReportID,0);">
                                <i class="fa-solid fa-plus"></i>
                            </button>
    
                            <button class="icon-btn icon-btn-danger mx-3" (click)="RemoveEmployee(mDtl.ID, mDtl.UserID)"
                                title="Delete">
                                <i class="fa fa-trash"></i>
                            </button>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>

}@else {
<!-- <my-content placeholder="navigation">

    <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>

    <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog-FactSheet">
            <div class="modal-content">
                <div class="modal-header BlueHeader">
                    <h4 class="Heading">{{ModalHeading}}</h4><br>
                    <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]('')"
                        data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body  col-sm-12 form-group">
                    <iframe width="100%" Height="400 px" frameBorder="0" [src]="modalURL|safe"></iframe>
                </div>
            </div>
        </div>
    </div>

    <div class="col-sm-12" style="margin-top: 8px;">
        <div class="col-sm-12"
            style="background-color: #eee; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">
            <div class="col-sm-4">
                <b>Escalation Configuration</b>
            </div>
            <div class="col-sm-4">&nbsp;</div>
            <div class="col-sm-4">&nbsp;</div>
        </div>
    </div>

    <div class="col-sm-12" style="margin-top: 8px;">

        <div class=" col-sm-12 lefticonD paddingless"
            style=" padding:10px;border-left:1px solid #ccc;border-top:1px solid #ccc; border-right:1px solid #ccc;">
            <form #SearchNoticeCase="ngForm" [formGroup]="FormSearchNoticeCase">
                <div class="col-sm-12 text-left">
                    <label *ngFor="let module of Modules;">
                        <input type="radio" formControlName="Modules" name="Modules" [value]="module.MainID"
                            [(ngModel)]="ModuleSelected" (change)="onModuleSelect(module.MainID)" />
                        {{module.MainDescr}}&nbsp;&nbsp;&nbsp;&nbsp;
                    </label>
                </div>
            </form>
        </div>



        <table width="100%" class="LMtable">
            <tr>
                <th rowspan="2">Report</th>
                <th rowspan="2">Employee</th>
                <th colspan="3" class="center">Level 1</th>
                <th colspan="3" class="center">Level 2</th>
                <th colspan="3" class="center">Level 3</th>
                <th rowspan="2" class="center">Non User Email</th>
                <th rowspan="2" class="center">Remove</th>
            </tr>
            <tr>
                <th class="center">Days</th>
                <th class="center">Interval</th>
                <th>Send Mail To</th>
                <th class="center">Days</th>
                <th class="center">Interval</th>
                <th>Send Mail To</th>
                <th class="center">Days</th>
                <th class="center">Interval</th>
                <th>Send Mail To</th>
            </tr>

            <tr *ngIf="this.MsgType == 1">
                <td colspan="80">
                    <div class="d-flex align-items-center">
                        <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                        <div class="spinner-border" role="status"></div>
                    </div>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 2">
                <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                    <span>{{DisplayMessage}}</span>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 3">
                <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                </td>
            </tr>

            <tr *ngFor="let mDtl of Data; let i=index">
                <td>
                    <div *ngIf="i == 0">
                        <a class="link" style="color:#337ab7;" data-toggle="modal"
                            (click)="OpenModalFeature('escalation-report-entry/' + mDtl.ReportID); "
                            data-target="#ModalPopUP">{{mDtl.ReportName}}</a>
                        <div style='float:right;'>
                            <a class="link" style="color:#337ab7; font-size: 10px;" data-toggle="modal"
                                (click)="OpenModal('escalation-user-entry',mDtl.ReportID,0); "
                                data-target="#ModalPopUP">Add Employee</a>
                        </div>
                    </div>
                    <div *ngIf="i > 0">
                        <div *ngIf="Data[i-1].ReportID != mDtl.ReportID">
                            <a class="link" style="color:#337ab7;" data-toggle="modal"
                                (click)="OpenModalFeature('escalation-report-entry/' + mDtl.ReportID); "
                                data-target="#ModalPopUP">{{mDtl.ReportName}}</a>
                            <div style='float:right;'>
                                <a class="link" style="color:#337ab7; font-size: 10px;" data-toggle="modal"
                                    (click)="OpenModal('escalation-user-entry',mDtl.ReportID,0); "
                                    data-target="#ModalPopUP">Add Employee</a>
                            </div>
                        </div>
                    </div>
                </td>

                <td>
                    <a class="link" style="color:#337ab7;" target="_blank" data-toggle="modal"
                        (click)="OpenModal('escalation-user-entry',mDtl.ReportID, mDtl.UserID); "
                        data-target="#ModalPopUP">{{mDtl.UserName}}</a>
                </td>
                <td class="center"> {{mDtl.L1Days}} </td>
                <td class="center"> {{mDtl.L1Interval}} </td>
                <td> {{mDtl.L1Users}} </td>

                <td class="center"> {{mDtl.L2Days}} </td>
                <td class="center"> {{mDtl.L2Interval}} </td>
                <td> {{mDtl.L2Users}} </td>

                <td class="center"> {{mDtl.L3Days}} </td>
                <td class="center"> {{mDtl.L3Interval}} </td>
                <td> {{mDtl.L3Users}} </td>
                <td> {{mDtl.Email}} </td>
                <td class="center">
                    <div *ngIf="mDtl.UserID > 0">
                        <a title="Remove Employee" (click)="RemoveEmployee(mDtl.ReportID, mDtl.UserID)"><i
                                class="material-icons">delete_forever</i></a>
                    </div>
                </td>
            </tr>
        </table>
        <br>
    </div>


    <div><br>&nbsp;</div>

    <div class="form-group mt-2" style="display:none;">
        <div class="form-check">
            <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true
                [(ngModel)]="options.autoClose">
            <label for="autoClose">Auto close alert after three seconds</label>
        </div>

    </div>
    <div class="jumbotron p-4">
        <div class="container text-center col-sm-4 alertCss">
            <app-alert></app-alert>
            <router-outlet></router-outlet>
        </div>
    </div>

</my-content>
<my-content placeholder="main">

</my-content> -->
}